export const DRAWER_ITEM_KEYS = {
  NEW_CHAT: 'NewChat',
  SEARCH: 'Search',
} as const;

export type DrawerItemKey = (typeof DRAWER_ITEM_KEYS)[keyof typeof DRAWER_ITEM_KEYS];
